(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-collection-description-toggle]');
    if (!toggle) return;

    var wrapper = toggle.closest('[data-collection-description]');
    if (!wrapper) return;

    var isExpanded = wrapper.getAttribute('data-expanded') === 'true';
    wrapper.setAttribute('data-expanded', isExpanded ? 'false' : 'true');
    toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');

    var moreLabel = toggle.querySelector('[data-label-more]');
    var lessLabel = toggle.querySelector('[data-label-less]');
    if (moreLabel && lessLabel) {
      moreLabel.hidden = !isExpanded;
      lessLabel.hidden = isExpanded;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
